import React from "react";

function TaskSubtaskRequirementBadge(props) {
  if (props.isOptional || props.type === "heading") {
    return null;
  }

  return (
    <span
      aria-label="Required"
      className={`inline-block text-rose-500 text-sm font-semibold leading-none ${props.className || ""}`}
    >
      *
    </span>
  );
}

export function TaskSubtaskNameWithRequirement({
  name,
  isOptional,
  type,
  badgeClassName = "",
}) {
  if (isOptional || type === "heading") {
    return name;
  }

  const subtaskName = name || "";
  const trimmedName = subtaskName.trimEnd();
  const lastSpaceIndex = trimmedName.lastIndexOf(" ");

  if (lastSpaceIndex === -1) {
    return (
      <span className="whitespace-nowrap">
        {subtaskName}
        <TaskSubtaskRequirementBadge
          isOptional={isOptional}
          type={type}
          className={`ml-1 align-baseline ${badgeClassName}`}
        />
      </span>
    );
  }

  return (
    <>
      {trimmedName.slice(0, lastSpaceIndex + 1)}
      <span className="whitespace-nowrap">
        {trimmedName.slice(lastSpaceIndex + 1)}
        <TaskSubtaskRequirementBadge
          isOptional={isOptional}
          type={type}
          className={`ml-1 align-baseline ${badgeClassName}`}
        />
      </span>
      {subtaskName.slice(trimmedName.length)}
    </>
  );
}

export default TaskSubtaskRequirementBadge;
